import React from 'react';
import { Lock, ClipboardList, Boxes, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../shared/context/UserContext';
import './DigitizationPage.css';

const lockWrapStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  padding: 'var(--space-8)',
  textAlign: 'center',
};

const iconStyle = { color: 'var(--color-text-secondary)', marginBottom: 'var(--space-4)' };

export default function DigitizationPage() {
  const { userProfile } = useUser();
  const navigate = useNavigate();
  const isAdmin = userProfile?.role === 'ADMIN';

  if (!isAdmin) {
    return (
      <div style={lockWrapStyle}>
        <Lock size={48} style={iconStyle} />
        <h1 style={{ margin: 0, color: 'var(--color-text-primary)', fontSize: '1.5rem', fontWeight: 600 }}>
          You do not have access
        </h1>
      </div>
    );
  }

  return (
    <div className="dig-screen">
      <header className="dig-header">
        <h1 className="dig-header-title">Digitization</h1>
        <p className="dig-header-sub">Capture and browse tooling inventory.</p>
      </header>

      <div className="dig-card-list">
        <button className="dig-card" onClick={() => navigate('/field')}>
          <span className="dig-card-icon"><Boxes size={32} strokeWidth={1.5} /></span>
          <span className="dig-card-text">
            <span className="dig-card-title">Field Inventory</span>
            <span className="dig-card-desc">Scan and record tools in the field.</span>
          </span>
          <span className="dig-card-chevron"><ChevronRight size={22} strokeWidth={1.5} /></span>
        </button>

        <button className="dig-card" onClick={() => navigate('/digitization/registry')}>
          <span className="dig-card-icon"><ClipboardList size={32} strokeWidth={1.5} /></span>
          <span className="dig-card-text">
            <span className="dig-card-title">Asset Registry</span>
            <span className="dig-card-desc">Browse and search all tooling records.</span>
          </span>
          <span className="dig-card-chevron"><ChevronRight size={22} strokeWidth={1.5} /></span>
        </button>
      </div>
    </div>
  );
}
